import { makeStyles, useTheme } from '@material-ui/core/styles';

export const Theme = useTheme;

export const useStyles = makeStyles(theme => ({
	label: {
		fontSize: 12,
		marginTop: 7
	},
	rootLabel: {
		alignItems: 'flex-start'
	},
	helperText: {
		marginTop: 10
	}
}));
